import { useEffect, useState } from "react";
import { BasicPage } from "../theme/Component/BasicPage";
import { CardTaps } from "../theme/Component/CardTaps";
import { Singleton } from "../../core/services/Singleton";
import { ExportUtil } from "./ExportUtil";
import { ImportUtil } from "./ImportUtil";
import { DaoUtil } from "./DaoUtil";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { _DaoInfo } from "../../core/services/dataBean/EntityCatalog";
import { Spinner } from "../../core/components/Spinner";
import { RemoteAbstractAction } from "./remoteAbstractAction/RemoteAbstractAction";
import { ToastContainer } from "react-toastify";
import { MenuUsuario } from "../admin/menu/MenuUsuario";
import { SystemRoles } from "../admin/Roles/SystemRoles";
import { AccountEditor } from "../editor/AccountEditor";
import { TestApi } from "./TestApi";
import { ExecuteCommand } from "./ExecuteCommand";
import { RestaurarRP } from "./remoteAbstractAction/RestaurarRP";
import { PrintZPL } from "./zpl/PrintZPL";
import Select from "react-select";
import { DocumentDocsManager } from "./DocumentDocs/DocumentDocsManager";
import { EraseTemTable } from "./EraseTemTable";

interface Props {
    view: string;
}
export const SystemUtil = ({ view }: Props) => {

    const [viewPage, setViewPage] = useState<boolean>(false);
    const single = Singleton.getInstance();
    const service = useDataBean(_DaoInfo);
    const [webService, setWebSerice] = useState<any>([]);
    const [indexTap, setIndexTap] = useState(0);

    const [daoList, setDaoList] = useState<any>([]);
    const [data, setData] = useState<any>({
        charset: "UTF-8"
    });
    const taps = [
        { id: 0, name: 'Exportar', disable: false },
        { id: 1, name: 'Importar', disable: false },
        { id: 2, name: 'Dao', disable: false },
        { id: 3, name: 'Catálogo de Aplicaciones por Tipo', disable: false },
        { id: 4, name: 'Menu del sistema', disable: false },
        { id: 5, name: 'Roles', disable: false },
        { id: 6, name: 'Usuario', disable: false },
        { id: 7, name: 'Test', disable: false },
        { id: 8, name: 'Command', disable: false },
        { id: 9, name: 'Restaurar RP', disable: false },
        { id: 10, name: 'Print ZPL', disable: false },
        { id: 11, name: 'Documentación Docs', disable: false },
        { id: 12, name: 'Borrar tablas temporales', disable: false },
    ];

    useEffect(() => {
        getDao();
    }, [view])
    useEffect(() => {

        if (indexTap === 2) {
            getWebServiceInfoCatalog();
        }
    }, [indexTap])

    const getWebServiceInfoCatalog = () => {
        service.instance.getWebServiceInfoCatalog(null).then(
            (resp: any) => {
                setWebSerice(resp);
            }
        )
    }

    const getDao = () => {
        service.instance.getDaoInfoCatalog(null).then(
            (resp: any) => {
                setDaoList(resp);
            }
        )
    }

    const optionsDao = daoList.map((item: any) => ({
        value: item.DataBeanProperties.IDDaoInfo,
        label: `${item.DataBeanProperties.ClassForName} - ${item.DataBeanProperties.Name ?? "No Definido"}`,
        item: item.DataBeanProperties,
    }));

    const selectedDaoOption = optionsDao.find(o => o.value === data.idDaoInfo) ?? null;

    const optionswebService = webService.map((item: any) => ({
        value: item.DataBeanProperties.IDWebServiceInfo,
        label: item.DataBeanProperties.ClassForName,
        item: item.DataBeanProperties,
    }));

    const selectedwebService = optionswebService.find(o => o.value === data.IDWebServiceInfo) ?? null;

    return (
        <>
            <Spinner />
            <ToastContainer
                newestOnTop
                position="top-right"
                autoClose={4000}
                hideProgressBar={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <div className="container">
                <div className="row mt-2">
                    {/* <PrintJson json={data}/> */}
                    <div className="col">
                        <BasicPage titulo="Propiedades del Sistema">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>Dao</label>
                                            <Select
                                                options={optionsDao}
                                                value={selectedDaoOption}
                                                onChange={(e) => {
                                                    const valor = e?.value ? Number(e?.value) : null;
                                                    const clasname = e?.item?.ClassForName ?? ""
                                                    setData({ ...data, idDaoInfo: valor, daoClassForName: clasname });
                                                }}
                                                isClearable
                                                placeholder="Daos disponibles..."
                                                noOptionsMessage={() => "Sin coincidencias"}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            {indexTap === 2 &&
                                                <>
                                                    <label>WebServiceInfo</label>
                                                    <Select
                                                        options={optionswebService}
                                                        value={selectedwebService}
                                                        onChange={(e) => {
                                                            const valor = e?.value ? Number(e?.value) : null;
                                                            const clasname = e?.item?.ClassForName ?? ""
                                                            setData({ ...data, IDWebServiceInfo: valor, webClassForName: clasname })
                                                        }}
                                                        isClearable
                                                        placeholder="WebServices disponibles..."
                                                        noOptionsMessage={() => "Sin coincidencias"}
                                                    />
                                                </>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mt-2">
                                    <strong>ClassForName Dao: </strong>{data.daoClassForName}
                                </div>
                                <div className="col-md-6 mt-2">
                                    <strong>ClassForName Service: </strong>{data.webClassForName}
                                </div>
                                <div className="col-md-12">
                                    <CardTaps taps={taps} updateIndex={setIndexTap} index={indexTap}>
                                        <div className="row">
                                            <div className="col">
                                                {indexTap === 0 &&
                                                    <ExportUtil data={data} />
                                                }
                                                {indexTap === 1 &&
                                                    <ImportUtil data={data} />
                                                }
                                                {indexTap === 2 &&
                                                    <DaoUtil classForName={data.webClassForName} daoclassForName={data.daoClassForName} />
                                                }
                                                {indexTap === 3 &&
                                                    <RemoteAbstractAction />
                                                }
                                                {indexTap === 4 &&
                                                    <MenuUsuario />
                                                }
                                                {indexTap === 5 &&
                                                    <SystemRoles />

                                                }
                                                {indexTap === 6 &&
                                                    <>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <AccountEditor idAccount={null} label="Busqueda y Gestion" onChange={() => { }} canCreate />
                                                            </div>

                                                        </div>
                                                    </>

                                                }
                                                {indexTap === 7 &&
                                                    <TestApi />
                                                }
                                                {indexTap === 8 &&
                                                    <ExecuteCommand />
                                                }
                                                {indexTap === 9 &&
                                                    <RestaurarRP />
                                                }
                                                {indexTap === 10 &&
                                                    <PrintZPL />
                                                }
                                                {indexTap === 11 &&
                                                    <DocumentDocsManager />
                                                }
                                                {indexTap === 12 &&
                                                    <EraseTemTable/>
                                                }
                                            </div>
                                        </div>
                                    </CardTaps>
                                </div>
                            </div>
                        </BasicPage>
                    </div>
                </div>
            </div>
        </>
    )
}